import { useSiteContext, formatPrice, Currency } from '@zooplus/commons-lang';

export const usePriceFormatter = () => {
  const { locale } = useSiteContext();

  function formatPriceWithLocale(price: number, currency: Currency) {
    return formatPrice(price, locale, currency);
  }

  return formatPriceWithLocale;
};
